<template>
    <div
        ref="label"
        @click="openFilters"
        class="clickable root noselect"
        style="min-width: 70px;"
    >
        <div class="d-inline-flex align-content-center label-wrapper">
            <div
                class="caption muted mb-0 secondary-color"
                style="line-height: normal; align-self: end; font-size: 15px;"
            >
                {{ label }}
            </div>
            <b-badge
                v-if="count"
                class="secondary-color light-gray lighten-background align-self-center ml-1"
                >{{ count }}</b-badge
            >
            <BaseIcon class="secondary-color" name="caret-down" size="xs" />
        </div>
        <div
            id="filters"
            v-if="showFilters"
            class="filter-wrapper"
            v-on-clickaway="closeFilters"
        >
            <h6
                v-for="(option, i) in options"
                :key="option.label + i"
                :class="[
                    'filter-item',
                    'text-center',
                    'p-3',
                    'h-100',
                    'clickable',
                    'mb-0',
                    'noselect',
                    isSelected(option.value)
                        ? 'secondary darken-on-hover selected'
                        : '',
                ]"
                @click="toggleFilter(option.value)"
            >
                {{ option.label }}
            </h6>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import Vue from 'vue';
export default {
    mixins: [clickaway],
    name: 'FilterBuilder',
    props: {
        label: String,
        labelValue: String,
        options: Array,
        settings: {
            type: Object,
            default: () => ({}),
        },
        value: Object,
        maxHeight: Number,
        yOffset: {
            type: Number,
            default: undefined,
        },
        /* skal se ut som {  options[valgt].value: 1  } */
    },
    data() {
        return {
            showFilters: false,
        };
    },
    methods: {
        openFilters() {
            // Toggle show
            this.showFilters = true;
        },
        closeFilters(event) {
            this.showFilters = false;
        },
        toggleFilter(value) {
            if (this.value) {
                if (this.value[this.labelValue][value]) {
                    delete this.value[this.labelValue][value];
                    this.emit({ ...this.value });
                } else {
                    if (this.count != this.settings.limit) {
                        this.value[this.labelValue][value] = 1;
                        this.emit({ ...this.value });
                    } else {
                        this.$interfaces.messageModule.addNewMessage({
                            title: this.$t(
                                'shared.searchModule.filterLimit.title'
                            ),
                            message: this.$t(
                                'shared.searchModule.filterLimit.message'
                            ),
                        });
                    }
                }
            }
            this.$forceUpdate();
        },
        isSelected(value) {
            if (this.value) {
                return this.value[this.labelValue][value] ? true : false;
            } else {
                return {};
            }
        },

        emit(val) {
            this.$emit('update:filter', val);
        },
    },
    mounted() {
        if (this.value && !(this.value[this.labelValue] instanceof Object))
            this.emit({
                ...this.value,
                [this.labelValue]: {},
            });
    },
    computed: {
        count() {
            return this.value
                ? Object.keys(this.value[this.$props.labelValue] || {}).length
                : 0;
        },
    },
};
</script>

<style scoped>
.root {
    position: relative;
}
#filters {
    position: absolute;
    z-index: 999;
    display: flex;
    flex-direction: column;
    background-color: white;

    min-width: calc(100% + 100px);

    overflow-y: auto;
}

.selected {
    color: white !important;
}

.filter-wrapper {
    max-height: 262px;
    border: 1px solid #eee;
}

.filter-item {
    border-bottom: 1px solid #eee;
}

.label-wrapper {
    margin-left: 10px;
    margin-right: 10px;
}

@media only screen and (max-width: 1000px) {
    #filters {
        min-width: 100%;
        position: unset;
        margin-top: 10px;
    }
}

#filters * {
    white-space: nowrap;
}
</style>
